export { default } from './ColoredSlider'
